/* 511c826a (c3858b9c part 2, UI half): Bambu send-to-print job types.
   The backend serializes Status as a PascalCase string ("Queued",
   "Printing", …) — ordinals stay accepted defensively (enum drift),
   same pattern as types/slicing.ts. */

export type PrintJobStatus =
  | 'Queued'
  | 'Printing'
  | 'Paused'
  | 'Finished'
  | 'Failed'
  | 'Canceled';

/** One send-to-print job as shown on the provider order page. */
export interface BambuPrintJob {
  id: string;
  orderId: string;
  printerId: string;
  printerName: string;
  slicingJobId: string;
  artifactFileName?: string | null;
  status: PrintJobStatus | number;
  /** Raw Bambu gcode_state ("RUNNING", "PAUSE", …) from the last live report. */
  gcodeState?: string | null;
  percent?: number | null;
  errorMessage?: string | null;
  createdAtUtc: string;
  startedAtUtc?: string | null;
  finishedAtUtc?: string | null;
}

export const PRINT_JOB_STATUSES: PrintJobStatus[] = [
  'Queued', 'Printing', 'Paused', 'Finished', 'Failed', 'Canceled',
];

export function normalizePrintJobStatus(status: PrintJobStatus | number): PrintJobStatus {
  if (typeof status === 'string') return status;
  return PRINT_JOB_STATUSES[status] ?? 'Failed';
}

export const PRINT_JOB_STATUS_LABELS: Record<PrintJobStatus, string> = {
  Queued: 'В очереди',
  Printing: 'Печатается',
  Paused: 'Пауза',
  Finished: 'Напечатан',
  Failed: 'Ошибка',
  Canceled: 'Остановлена',
};

export function printJobStatusBadgeClass(status: PrintJobStatus): string {
  switch (status) {
    case 'Printing':
    case 'Paused':
      return 'badge badge-warning';
    case 'Finished':
      return 'badge badge-success';
    case 'Failed':
      return 'badge badge-danger';
    default:
      return 'badge badge-neutral';
  }
}
